import { useContext } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import './index.css';

export const PleaseWait = () => {
  const { pleaseWait } = useContext(ModalAlertContext);

  if (!pleaseWait) return null;

  return (
    <div className="please-wait" style={pleaseWait.customStyle} >
      <div className="please-wait-content" style={pleaseWait.customContentStyle}>
        <div className="please-wait-content-icon">

          <svg xmlns="http://www.w3.org/2000/svg" width="105" height="105" viewBox="0 0 105 105" fill="none">
            <circle cx="52.5" cy="52.5" r="47.5" stroke="#C0C0C0" stroke-width="10" />
            <path d="M100 52.5C100 46.2622 98.7714 40.0855 96.3843 34.3225C93.9972 28.5596 90.4983 23.3232 86.0876 18.9124C81.6768 14.5016 76.4404 11.0028 70.6775 8.61572C64.9145 6.22862 58.7378 5 52.5 5" stroke="#7A63FF" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </div>
        <div className="please-wait-content-texts">
          <div className="please-wait-content-title">
            {pleaseWait.title}
          </div>
          <div className="please-wait-content-description">
            {pleaseWait.message}
          </div>
        </div>
      </div>
    </div>
  );
};